export const RENEWAL_CARD_CTA_AMPLITUDE = {
  SOURCE: 'Learn Dashboard',
  SOURCE_DETAIL: 'Renewal Panel',
};

export const RENEWAL_CARD_TRANSLATION_KEY = 'learn-dashboard-renewal-card';
